import React, { Component } from 'react';
import { TextOnly } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * The about us section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class AboutView extends Component {

	render () {
		const {
			content,
			heading,
			subheading,
		} = this.props.content.landingPage.about;

		return (
			<TextOnly
				{...{
					content,
					heading,
					subheading,
				}}
			/>
		);
	}

}

export default withLanguageContext(AboutView);



// WEBPACK FOOTER //
// ./src/components/views/AboutView/AboutView.js